<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.Teams.show") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required disabled />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required disabled/>
          <!-- End:: Name Input -->
          <!-- Start:: Sport Input -->
          <base-input col="6" type="text" :placeholder="$t('SIDENAV.Leagues.league')" v-model.trim="data.sport" disabled />
          <!-- End:: Sport Input -->
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input col="6" identifier="image" :preSelectedImage="data.image.path"
                                   :placeholder="$t('PLACEHOLDERS.image')" required disabled />
          <!-- End:: Image Upload Input -->
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.active" hide-details disabled></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>

export default {
  name: "showTeam",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        sport: null,
        active: true,
        image: {
          path: null,
          file: null,
        },
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
  },

  methods: {
    // start show data
    async showTeam() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `teams/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.Team.trans.name.ar;
        this.data.nameEn = res.data.data.Team.trans.name.en;
        this.data.active = res.data.data.Team.is_active;
        this.data.image.path = res.data.data.Team.image;
        this.data.sport = res.data.data.Team.league.name;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data


  },

  created() {
    // Start:: Fire Methods
    this.showTeam();
    // End:: Fire Methods
  },
};
</script>
